
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageSquare, FileText, Users, CheckCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const FeaturesSection = () => {
  const { t } = useLanguage();
  
  const features = [
    {
      title: t('features.upload.title'),
      description: t('features.upload.description'),
      icon: FileText
    },
    {
      title: t('features.access.title'),
      description: t('features.access.description'),
      icon: MessageSquare
    },
    {
      title: t('features.questions.title'),
      description: t('features.questions.description'),
      icon: Users
    },
    {
      title: t('features.answer.title'),
      description: t('features.answer.description'),
      icon: CheckCircle,
    }
  ];

  return (
    <section id="funktioner" className="bg-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A237E] mb-12">
          {t('features.title')}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="text-center border-[#E6EEF5] hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-col items-center">
                <div className="text-4xl font-bold text-[#1A237E] mb-4">{index + 1}</div>
                <CardTitle className="text-lg text-[#1A237E] mb-4 h-14 flex items-center justify-center">{feature.title}</CardTitle>
                <div className="w-16 h-16 bg-[#F4F6F8] rounded-full flex items-center justify-center">
                  <feature.icon className="w-8 h-8 text-[#2F80ED]" />
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-[#0061A8]">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
